import CreateNewAccount from "@/components/users/CreateNewAccount"
import UserLogin from "@/components/users/UserLogin"
// import useIsMobile from "@/hooks/useIsMobile"
import CloseIcon from "@mui/icons-material/Close"
import { Box, Button, Modal, Typography } from "@mui/material"
import { useState } from "react"
import { DialogProps } from "../types"

interface LoginDialogProps extends DialogProps {
  message?: string
}

export default function LoginDialog({
  isOpen,
  closeDialog,
  message,
}: LoginDialogProps) {
  function handleClose() {
    closeDialog()
  }
  const [activeTab, setActiveTab] = useState(1)
  return (
    <Modal open={isOpen} onClose={handleClose} sx={{ zIndex: 9999 }}>
      <Box
        sx={{
          backgroundColor: "white",
          position: "absolute" as const,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: 24,
          borderRadius: "8px",
          minWidth: "500px",
          overflow: "hidden",
        }}
      >
        <header
          style={{
            display: "flex",
            backgroundColor: "#FFFFFF",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "50px",
          }}
        >
          <Button
            style={{
              textAlign: "left",
              height: "100%",
              display: "flex",
              width: "100%",
              backgroundColor: activeTab !== 2 ? "#FFFFFF" : "#F0F2F5",
            }}
            onClick={() => setActiveTab(1)}
          >
            <Typography>Login</Typography>
          </Button>
          <Button
            style={{
              width: "100%",
              textAlign: "left",
              height: "100%",
              backgroundColor: activeTab !== 1 ? "#FFFFFF" : "#F0F2F5",
            }}
            onClick={() => setActiveTab(2)}
          >
            <Typography>Create New Account</Typography>
          </Button>
          <div
            style={{
              // padding: ".5rem",
              // background: "#F0F2F5",
              display: "flex",
              alignItems: "center",
              backgroundColor: activeTab !== 1 ? "#FFFFFF" : "#F0F2F5",
              // width: "50px",
              height: "100%",
            }}
          >
            <Button onClick={handleClose}>
              <CloseIcon />
            </Button>
          </div>
        </header>
        <Box display="flex" justifyContent="center" paddingTop={4}>
          <Typography>{message}</Typography>
        </Box>
        <Box sx={{ padding: "2rem" }}>
          {activeTab === 1 ? <UserLogin /> : <CreateNewAccount />}
        </Box>
      </Box>
    </Modal>
  )
}
